"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XYChartComponent = void 0;
var React = __importStar(require("react"));
var core_1 = require("@amcharts/amcharts4/core");
var animated_1 = __importDefault(require("@amcharts/amcharts4/themes/animated"));
var chartTheme_1 = require("./chartTheme");
var react_fast_compare_1 = __importDefault(require("react-fast-compare"));
var multiChartLayoutHelper_1 = require("./multiChartLayoutHelper");
core_1.addLicense("CH200401233957118");
var defaultThemes = [
    animated_1.default,
    chartTheme_1.snTheme,
    chartTheme_1.snAnimatedTheme
];
var printThemes = [
    chartTheme_1.snTheme
];
// Not react hooks, just functions named "use..."
// eslint-disable-next-line react-hooks/rules-of-hooks
var useDefaultThemes = function () { return defaultThemes.forEach(function (theme) { return core_1.useTheme(theme); }); };
// eslint-disable-next-line react-hooks/rules-of-hooks
var unusedDefaultThemes = function () { return defaultThemes.forEach(function (theme) { return core_1.unuseTheme(theme); }); };
// eslint-disable-next-line react-hooks/rules-of-hooks
var usePrintThemes = function () { return printThemes.forEach(function (theme) { return core_1.useTheme(theme); }); };
// eslint-disable-next-line react-hooks/rules-of-hooks
var unusedPrintThemes = function () { return printThemes.forEach(function (theme) { return core_1.unuseTheme(theme); }); };
var XYChartComponent = /** @class */ (function (_super) {
    __extends(XYChartComponent, _super);
    function XYChartComponent(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.createReadyMarkerDiv = function () {
            var id = "chart-ready";
            if (!document.getElementById(id)) {
                var elem = document.createElement('div');
                elem.setAttribute("id", id);
                document.body.append(elem);
            }
            // for wkhtml2pdf
            window.status = "PDF_DONE";
            console.log("Created READY markers.");
        };
        _this.createChart = function () {
            if (!window.printLayout) {
                unusedPrintThemes();
                // eslint-disable-next-line react-hooks/rules-of-hooks
                useDefaultThemes();
            }
            else {
                console.log("Disabling chart animations for quicker printing.");
                unusedDefaultThemes();
                // eslint-disable-next-line react-hooks/rules-of-hooks
                usePrintThemes();
            }
            var chartFactory = _this.props.chartFactory;
            if (Array.isArray(chartFactory)) {
                _this.disposables = new multiChartLayoutHelper_1.MultiChartLayoutHelper(_this.chartElemId, chartFactory).createCharts(_this.createReadyMarkerDiv);
            }
            else {
                _this.disposables = [chartFactory.createChart(_this.chartElemId, _this.createReadyMarkerDiv)];
            }
        };
        _this.disposeChart = function () {
            if (_this.disposables) {
                _this.disposables.forEach(function (chart) { return chart.dispose(); });
            }
        };
        _this.chartElemId = (_a = props.chartElemId) !== null && _a !== void 0 ? _a : "chartDiv-" + Math.random();
        return _this;
    }
    XYChartComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
        var propsEqual = react_fast_compare_1.default(prevProps, this.props);
        var stateEqual = react_fast_compare_1.default(prevState, this.state);
        if (propsEqual && stateEqual)
            return;
        this.disposeChart();
        this.createChart();
    };
    XYChartComponent.prototype.componentDidMount = function () {
        this.createChart();
    };
    XYChartComponent.prototype.componentWillUnmount = function () {
        this.disposeChart();
    };
    XYChartComponent.prototype.render = function () {
        return (React.createElement("div", { className: "main" },
            React.createElement("div", { className: "main-chart-div", id: this.chartElemId }),
            this.props.chartFooterComponent));
    };
    return XYChartComponent;
}(React.Component));
exports.XYChartComponent = XYChartComponent;
